export function scheduledMessageDomId(id: string): string {
  return `scheduled-message-${id}`;
}

export function focusScheduledMessage(id: string): void {
  const el = document.getElementById(scheduledMessageDomId(id));
  if (el) {
    el.scrollIntoView({ block: "nearest", behavior: "smooth" });
    el.focus({ preventScroll: true });
  }
}
